module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Design/Cap-2-a18d00561a8964d2e44eea455eb2dea7.svg";